import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { LOGON_INFO, SERVER } from "../app.constants";


@Injectable()
export class StateRegistService {

    constructor(
        private _htc: HttpClient
    ) { }


    getAllBranchStateList(branch: string, year: string, month: string): Observable<any> {
        return this._htc.get<any>(SERVER.baseURL + '/state-list-all/' + branch + '/' + year + (month.length == 1 ? '0' + month : month) + '/' + LOGON_INFO.USER_ID);
    }

    getSrcBranchStateList(branch: string, year: string, month: string, billList: string, custList: string, siteList: string, prodList: string): Observable<any> {
        let params = new HttpParams().set('billList', billList).set('custList', custList).set('siteList', siteList).set('prodList', prodList);
        return this._htc.get<any>(SERVER.baseURL + '/state-list-src/' + branch + '/' + year + (month.length == 1 ? '0' + month : month) + '/', { params: params });
    }

    getSrcBranchStateListAll(branch: string, year: string, month: string, billList: string, custList: string, siteList: string, prodList: string): Observable<any> {
        let params = new HttpParams().set('billList', billList).set('custList', custList).set('siteList', siteList).set('prodList', prodList);
        return this._htc.get<any>(SERVER.baseURL + '/state-list-src-all/' + branch + '/' + year + (month.length == 1 ? '0' + month : month) + '/', { params: params });
    }

    getPageStateList(link: string): Observable<any> {
        return this._htc.get<any>(link);
    }

    getStatePath(branch: string, year: string, month: string): Observable<StatementRegist[]> {
        return this._htc.get<StatementRegist[]>(SERVER.baseURL + '/car-state-path/' + branch + '/' + year + (month.length == 1 ? '0' + month : month) + '/');
    }

    getSearchBilling(branch: string, year: string, month: string): Observable<any> {
        return this._htc.get(SERVER.baseURL + '/state-search-billing/' + branch + '/' + year + (month.length == 1 ? '0' + month : month) + '/');
    }

    getSearchCustomer(branch: string, year: string, month: string): Observable<any> {
        return this._htc.get(SERVER.baseURL + '/state-search-customer/' + branch + '/' + year + (month.length == 1 ? '0' + month : month) + '/');
    }

    getSearchSite(branch: string, year: string, month: string): Observable<any> {
        return this._htc.get(SERVER.baseURL + '/state-search-site/' + branch + '/' + year + (month.length == 1 ? '0' + month : month) + '/');
    }

    getSearchProduct(branch: string, year: string, month: string): Observable<any> {
        return this._htc.get(SERVER.baseURL + '/state-search-product/' + branch + '/' + year + (month.length == 1 ? '0' + month : month) + '/');
    }

    getStateFreeTitle(branch: string, year: string, month: string): Observable<any> {
        const parentCompId = LOGON_INFO.PARENT_COMP_ID;
        const ym = year + (month.length === 1 ? '0' + month : month);
        return this._htc.get<any>(SERVER.baseURL + '/state-free-title/' + parentCompId + '/' + branch + '/' + ym + '/');
    }



    registStatement(state: StatementRegist, branch: string, year: string, month: string): Observable<StatementRegist> {
        state.parent_comp_id = LOGON_INFO.PARENT_COMP_ID;
        state.comp_id = branch;
        state.regist_period = year + (month.length == 1 ? '0' + month : month);
        state.create_id = LOGON_INFO.USER_ID;

        const form_data = this.getFormData(state);
        return this._htc.post<StatementRegist>(SERVER.baseURL + '/car-state-regist/', form_data);
    }

    getFormData(state: StatementRegist): FormData {
        const form_data = new FormData();
        form_data.append('parent_comp_id', state.parent_comp_id);
        form_data.append('comp_id', state.comp_id);
        form_data.append('create_id', state.create_id);
        if (state.statement_excel_file) {
            form_data.append('statement_excel_file', state.statement_excel_file, state.statement_excel_name);
        }
        form_data.append('statement_excel_name', state.statement_excel_name);
        form_data.append('regist_period', state.regist_period);

        return form_data;
    }
}


export class Statement {
    comp_id: string;
    statement_ym: string;
    transfer_date: Date;
    // transfer_date: string;
    affiliation: string;
    parent_comp_name: string;
    comp_name: string;
    car_no: string;
    car_owner: string;
    car_type: string;
    billing_comp: string;
    customer_comp: string;
    construction_area: string;
    site_name: string;
    product_name: string;
    classification: string;
    day_night: string;
    quantity_1: number;
    rack_1: string;
    summary_1: string;
    summary_2: string;
    unit_cost_1: number;
    night_cost_1: number;
    holiday_cost_1: number;
    amount_money_1: number;
    quantity_2: number;
    rack_2: string;
    unit_cost_2: number;
    night_cost_2: number;
    holiday_cost_2: number;
    special_demand_2: number;
    extra_cost_1: number;
    extra_cost_2: number;
    amount_money_2: number;
    margin: number;
    charge: number;
    mileage: number;
    fuel_cost: number;
    express_fee: number;
    quantity_3: number;
    rack_3: string;
    unit_cost_3: number;
    special_demand_3: number;
    amount_money_3: number;

    create_id: string;
    create_date: Date;

    // フリー枠項目 (数値タイプ)
    free_item_1: number;
    free_item_2: number;

    is_print_target: boolean;
    id: number;
}

export class StatementRegist {
    parent_comp_id: string;
    comp_id: string;
    create_id: string;
    create_date: Date;

    statement_excel: string;
    statement_excel_file: File;
    statement_excel_name: string;
    s3_path: string;
    regist_period: string;
}



// WEBPACK FOOTER //
// ./src/app/statement/state-regist.service.ts